import { Constants } from '../../app.const';

export class IssueConstants {

    public static basicConstans: any = Constants;

    public static baseUrl: string = Constants.baseUrl;
    public static apiUrl: string = Constants.baseUrl+Constants.apiVersioning;
    public static appUrl: string = Constants.appUrl;
    public static loginUrl: string = Constants.loginUrl;
    public static imageUrl: string = Constants.imageUrl;
    public static apiVersioning: string = Constants.apiVersioning;
    public static endPoint: string = Constants.endPoint;

    //PARAMS

    //API 
    

    //ROUTES
    

    //LINK
    

    //ROUTE_DATA
    
    
};


// WEBPACK FOOTER //
// ./src/app/modules/issues/issues.const.ts